import { put, takeEvery } from 'redux-saga/effects'
import { USERDEFINEDFIELDS_LOADING, USERDEFINEDFIELDS_DATA_SUCCESS, USERDEFINEDFIELDS_DATA_ERROR } from "../actions/actionBookingUserDefinedFields";
import { apiUserDefinedFields } from 'api';

async function fetchAsync(func, payload) {
    const response = await func(payload);
    if (response.status == 200) {
        return await response.json();
    }
    else if (response.status == 202 || response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get booking user defined fields, response status: " + response.status + "\"}]}")
    }
}

function* GetUserDefinedFields(action) {
    try {
        let udfsresponse = yield fetchAsync(apiUserDefinedFields, action);
        yield put({ type: USERDEFINEDFIELDS_DATA_SUCCESS, payload: udfsresponse });
    } catch (e) {
        yield put({ type: USERDEFINEDFIELDS_DATA_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaBookingUserDefinedFields = [
    takeEvery(USERDEFINEDFIELDS_LOADING, GetUserDefinedFields),
];
